import { Icon } from '@zenid/web';
import { css } from '../../../../../styled-system/css';
import { flex } from '../../../../../styled-system/patterns';
import { PastOrganizations } from './PastOrganizations';
import type { CurrentOrganizationsProps } from './CurrentOrganizations/CurrentOrganizations';
import { CurrentOrganizations } from './CurrentOrganizations/CurrentOrganizations';
import type { PastOrganizationsProps } from './PastOrganizations/PastOrganizations';
import { shouldMembershipBeShown } from './shouldMembershipBeShown';

type OrganizationsProps = Pick<CurrentOrganizationsProps, 'currentMemberships'> &
  Pick<PastOrganizationsProps, 'pastMemberships'>;

export function Organizations({ currentMemberships, pastMemberships }: OrganizationsProps) {
  return (
    <div className={flex({ minWidth: '343px', flexDirection: 'column', sm: { maxWidth: '720px' } })}>
      <div
        className={flex({
          flexDirection: 'row',
          alignItems: 'center',
          gap: '{spacing.4}',
          marginBottom: '{spacing.20}',
        })}
      >
        <Icon name="badge" color="colors.text.main" size="m" />
        <h2 className={css({ textStyle: 'headding.s', sm: { textStyle: 'headding.l' } })}>所属情報</h2>
      </div>
      <CurrentOrganizations
        currentMemberships={currentMemberships.filter((m) => shouldMembershipBeShown(m, { isCurrentMembership: true }))}
      />
      <PastOrganizations pastMemberships={pastMemberships.filter((m) => shouldMembershipBeShown(m))} />
    </div>
  );
}
